export defaultTemplate from './default';
export inhouseTemplate from './inhouse';
export sponsorTemplate from './sponsor';
export partnerstudioTemplate from './partnerstudio';



/** WEBPACK FOOTER **
 ** ./src/ads/native-templates/index.js
 **/